var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_878_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8227 0.0619354H9.36273C4.63518 0.0619354 0.802734 3.89438 0.802734 8.62194V84.0819C0.802734 88.8095 4.63518 92.6419 9.36273 92.6419H84.8227C89.5503 92.6419 93.3827 88.8095 93.3827 84.0819V8.62194C93.3827 3.89438 89.5503 0.0619354 84.8227 0.0619354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6331 36.0619H27.9531C28.1031 26.2119 34.1131 21.4119 45.7831 21.4219C47.2831 21.4219 51.7631 21.4219 51.7631 21.4219C53.5531 21.5219 54.9231 23.0419 54.8331 24.8319L54.6331 36.0619Z",
    fill: "#FFDB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8136 35.9519C31.2336 44.7719 37.4436 47.8719 46.3136 48.3319L48.8836 48.4719L48.2936 47.2419C47.8736 46.3619 48.8336 45.4519 49.6836 45.9319L57.0336 50.0419C57.9636 50.5619 57.5536 51.9719 56.4936 51.9219L44.1536 51.2619C34.2336 50.7319 27.4236 46.2119 27.9636 36.0519L31.8236 35.9419L31.8136 35.9519Z",
    fill: "#FFDB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2132 57.2019H66.2332C65.7432 64.2519 57.7532 71.7619 48.4132 71.2619H36.2832C34.4932 71.1619 33.1232 69.6419 33.2132 67.8519V57.2019Z",
    fill: "#FFDB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5239 57.5219C63.1039 48.7019 56.7539 44.8119 47.8939 44.3519L45.3239 44.2119L45.9139 45.4419C46.3339 46.3219 45.3739 47.2319 44.5239 46.7519L37.1739 42.6419C36.2439 42.1219 36.6539 40.7119 37.7139 40.7619L50.0539 41.4219C59.9739 41.9519 66.7839 47.5719 66.2439 57.7219L62.5239 57.5219Z",
    fill: "#FFDB33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.58,
    height: 92.58,
    fill: "white",
    transform: "translate(0.802734 0.0619354)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitIcon);
export default __webpack_public_path__ + "static/media/split-icon.b8e5a122d06a1465047008fdbdf55615.svg";
export { ForwardRef as ReactComponent };